/* eslint-disable eqeqeq */
import * as types from '@/store/types'
export default {
    allMailingGroups: state => {
        return state.mailingGroups
    },
    clients: state => {
        return state.clients
    },
    getClientByUserId: state => userId => {
        return state.clients.find(client => client.user_id === userId)
    },
    getClientRef: state => clientModel => {
        return state.clients.find(client => (client.id == clientModel.ref && client.platform === clientModel.platform))
    },
    getFirstClient: state => {
        return state.clients[0]
    },
    getLastClient: state => {
        return state.clients[state.clients.length - 1]
    },
    getCountClients: state => {
        return state.clientsCount
    },
    mailingGroups: state => {
        return state.mailingGroups.filter(mailingGroups => mailingGroups.id > 1)
    },
    getMailingGroupById: state => id => {
        return state.mailingGroups.find(mailingGroup => mailingGroup.id === id)
    },
    mailingGroupsLoaded: state => {
        return state.mailingGroupsLoaded
    },
    mailingGroupModelDef: state => {
        return state.mailingGroupModelDef
    },
    getIndexMailingGroupById: state => id => {
        return state.mailingGroups.findIndex(mailingGroup => mailingGroup.id === id)
    },
    tree: state => {
        return state.tree
    }
}
